import React, { useEffect, useState } from "react";
import { Button, Col, Row, Stack } from "react-bootstrap";
import RoomManagementCard from "./RoomManagementCard";
import Input from "../../ui/Input";
import { unsavedChanges } from "../../../App";
import { postRoom } from "../../../services/httpClient";

interface RoomState {
  getItems: any;
  rooms: any[];
  setShowRooms: any;
  setOrgToSave: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
  filterRoom: any;
}

const RoomManagement = ({ getItems, rooms, setShowRooms, setOrgToSave, setShowToast, setToastText, setToastBody, filterRoom }: RoomState) => {
  const [errMsg, setErrMsg] = useState("");
  const [newRoom, setNewRoom] = useState<string>("");
  const [firstTime, setFirstTime] = useState(false);
  const [showAddRoom, setShowAddRoom] = useState(false);
  const [saveEnabled, setSaveEnabled] = useState(false);

  useEffect(() => {
    if (rooms.length === 0) {
      setFirstTime(true);
      setShowAddRoom(true);
    }
  }, [rooms]);

  const onClickAddRoom = () => {
    setShowAddRoom(true);
  };

  const updateNewRoom = (e: any) => {
    setNewRoom(e.target.value);
    setSaveEnabled(true);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const onClickSaveRoom = (isDone: boolean = false) => {
    const roomObject = {
      name: newRoom,
    };

    postRoom(roomObject)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Room Created");
        setToastBody(newRoom);
        setNewRoom("");
        setSaveEnabled(false);
        unsavedChanges.value = false;
        setOrgToSave(false);
        if (isDone) {
          if (firstTime) {
            setShowRooms(false);
          }

          setShowAddRoom(false);
        }
        getItems(true);
      })
      .catch((err: any) => {
        setErrMsg(err?.response?.data?.msg);
      });
  };

  const onClickDoneAddRoom = () => {
    if (firstTime && rooms.length > 0) {
      setShowRooms(false);
    }

    setShowAddRoom(false);
    setNewRoom("");
    setSaveEnabled(false);
    unsavedChanges.value = false;
    setOrgToSave(false);
  };

  return (
    <>
      <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
        {errMsg}
      </p>
      <Row className="mt-3">
        <Col xs={12} xl={10}>
          {rooms.length === 0 ? (
            <p className="mt-2">No Rooms Created</p>
          ) : (
            <Stack gap={2}>
              {rooms?.map((item: any, index: number) => (
                <Row key={index}>
                  <Col xs={12}>
                    <RoomManagementCard
                      item={item}
                      getItems={getItems}
                      showAddRoom={showAddRoom}
                      setShowAddRoom={setShowAddRoom}
                      setOrgToSave={setOrgToSave}
                      setErrMessage={setErrMsg}
                      setShowToast={setShowToast}
                      setToastText={setToastText}
                      setToastBody={setToastBody}
                      filterRoom={filterRoom}
                    />
                  </Col>
                </Row>
              ))}
            </Stack>
          )}
        </Col>
      </Row>
      {showAddRoom !== true && (
        <Row className="mt-3">
          <Col xs={4}>
            <Button className="app-tertiary-color button" onClick={(e) => onClickAddRoom()}>
              Add Room
            </Button>
          </Col>
        </Row>
      )}
      {showAddRoom === true && (
        <>
          <Row className="align-items-center my-3">
            <Col xs={12} lg={10} xl={8}>
              <Input
                label="Room Name"
                type="text"
                value={newRoom}
                onUpdate={(e: any) => updateNewRoom(e)}
                hasFocus={true}
                required={true}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={10} xl={8}>
              <Stack direction="horizontal" gap={3}>
                <Button className="app-secondary-color button" onClick={() => onClickSaveRoom(false)} disabled={!saveEnabled}>
                  Save and Add Another
                </Button>
                <div className="vr" />
                <Button className="app-secondary-color button" onClick={() => onClickSaveRoom(true)} disabled={!saveEnabled}>
                  Save and Done
                </Button>
                <div className="vr" />
                <Button className="app-primary-color button" onClick={() => onClickDoneAddRoom()}>
                  Done
                </Button>
              </Stack>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default RoomManagement;
